import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const CardGridStyles = makeStyles((theme) => ({
  container: {
    padding: "0 55px 50px 55px",
    margin: "10px 0 40px"
  },
  containerMore: {
    padding: "30px 40px 10px 40px",
    borderRadius: "20px",
    background: COLORS.SECONDARY_LIGHTEST,
    margin: "0",
    "& a": {
      color: "inherit",
      textDecoration: "underline",
    },
  },
  
  header: {
    textAlign: "center",
    marginBottom: 60
  },
  headline: {
    textAlign: "left"
  },
  linkContainer: {
    color: COLORS.ACCENT2,
    textDecoration: "underline",
    fontWeight: 600
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "1.25rem"
  },
  headerText: {
    marginBottom: ".9rem"
  },
  headerDesc: {
    marginBottom: "0rem",
    maxWidth: "50rem"
  },
  gridItem: {
    display: "flex"
  }
}));

export default CardGridStyles;
